import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { CreditCard, Loader2 } from "lucide-react";

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Opens the Stripe Customer Billing Portal for subscribers; routes non-subscribers
// to Pricing. Throws on failure so callers can toast. Shared by the button + AppMenu.
export async function openBillingPortal(navigate) {
  const res = await fetch(`${API_URL}/api/subscriptions/create-portal`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ origin_url: window.location.origin }),
  });
  if (res.status === 400) { navigate("/pricing"); return; }
  const data = await res.json();
  if (!res.ok || !data.url) throw new Error(data.detail || "Could not open billing portal");
  window.location.href = data.url;
}

// "My Account" — opens the Stripe Customer Billing Portal for subscribers
// (manage/cancel/update card/invoices). Non-subscribers are sent to Pricing.
export const ManageBillingButton = ({ className = "", label = "My Account" }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const openPortal = async () => {
    setLoading(true);
    try {
      await openBillingPortal(navigate);
    } catch (err) {
      toast.error(err.message || "Could not open billing portal");
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      type="button"
      onClick={openPortal}
      disabled={loading}
      className={className || "inline-flex items-center gap-1.5 text-sm text-slate-400 hover:text-emerald-400 transition disabled:opacity-60"}
      data-testid="my-account-btn"
    >
      {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <CreditCard className="w-4 h-4" />}
      {label}
    </button>
  );
};

export default ManageBillingButton;
